import InfinityEnums from 'Enums/InfinityEnums'
import { Colors } from 'Theme'

export const calculateConnectorsHeight = (chargePointConnectors) => {
  // 48 connector height
  // 8 connector padding
  // 12 list padding
  // 23 List header height
  if (chargePointConnectors) {
    const connectors = chargePointConnectors.filter((conn) => conn.uid !== 0)
    if (connectors.length > 1)
      return `${
        48 * connectors.length + 8 * (connectors.length - 1) - (8 + 20)
      }px`
    else return '68px'
  }
}

export const calculateOuterContainerHeight = (chargePointConnectors) => {
  // 48 connector height
  // 8 connector padding
  // 12 list padding
  // 23 List header height
  if (chargePointConnectors) {
    const connectors = chargePointConnectors.filter((conn) => conn.uid !== 0)
    if (connectors.length > 1)
      return `${48 * connectors.length + 8 * (connectors.length - 1)}px`
    else return '104px'
  }
}

// Availability-toggle mapper: an in-use connector (Occupied / any fine energy
// state) is still administratively "Available"; only Unavailable/Faulted are
// "Unavailable". Post status-model inversion the connector reports the coarse
// `Occupied`, so it joins the Available group alongside the legacy fine values
// and the session-level EVConnected.
export const mapStatus = (status) => {
  switch (status) {
    case InfinityEnums.ConnectorStatus.AVAILABLE:
    case InfinityEnums.ConnectorStatus.PREPARING:
    case InfinityEnums.ConnectorStatus.CHARGING:
    case InfinityEnums.ConnectorStatus.SUSPENDEDEV:
    case InfinityEnums.ConnectorStatus.SUSPENDEDEVSE:
    case InfinityEnums.ConnectorStatus.FINISHING:
    case InfinityEnums.ConnectorStatus.OCCUPIED:
    case InfinityEnums.ChargingSessionChargingState.EVCONNECTED:
    case InfinityEnums.ConnectorStatus.RESERVED:
      return { color: Colors.AvailableConnector, text: 'Available' }
    case InfinityEnums.ConnectorStatus.UNAVAILABLE:
    case InfinityEnums.ConnectorStatus.FAULTED:
      return { color: Colors.UnAvailableConnector, text: 'Unavailable' }
    default:
      return Colors.black
  }
}

// The fine status to display in the connector detail view and to gate Start/Stop.
// In detail views the connector carries its active session, whose fine energy
// state (chargingState: Charging/SuspendedEV/SuspendedEVSE/EVConnected) is what
// operators expect to see. When no session is attached (the station list / map /
// count endpoints don't join it) fall back to the coarse connector status
// (Occupied/Available/Reserved/...).
export const getConnectorDisplayStatus = (connector) => {
  if (!connector) return undefined
  return connector.session?.chargingState || connector.status
}
export const handleMaxPower = (maxPower) => {
  if (maxPower <= InfinityEnums.ConnectorPowerLevel.LEVEL1)
    return InfinityEnums.ChargingSpeedLevels.LEVEL1
  else if (maxPower <= InfinityEnums.ConnectorPowerLevel.LEVEL2)
    return InfinityEnums.ChargingSpeedLevels.LEVEL2
  else return InfinityEnums.ChargingSpeedLevels.LEVEL3
}

export const mapType = (type) => {
  switch (type) {
    case InfinityEnums.OldConnectorType.TYPE_1:
      return InfinityEnums.ConnectorType.IEC_62196_T1
    case InfinityEnums.OldConnectorType.TYPE_1_CCS:
      return InfinityEnums.ConnectorType.IEC_62196_T1_COMBO
    case InfinityEnums.OldConnectorType.TYPE_2:
      return InfinityEnums.ConnectorType.IEC_62196_T2
    case InfinityEnums.OldConnectorType.SCHUKO:
      return InfinityEnums.ConnectorType.DOMESTIC_F
    case InfinityEnums.OldConnectorType.GBT_AC:
      return InfinityEnums.ConnectorType.GBT_AC
    case InfinityEnums.OldConnectorType.COMBO_CCS:
      return InfinityEnums.ConnectorType.IEC_62196_T2_COMBO
    case InfinityEnums.OldConnectorType.CHADEMO:
      return InfinityEnums.ConnectorType.CHADEMO
    case InfinityEnums.OldConnectorType.GBT_DC:
      return InfinityEnums.ConnectorType.GBT_DC
    case InfinityEnums.OldConnectorType.NACS:
      return InfinityEnums.ConnectorType.TESLA_S
    default:
      return type
  }
}

export const mapTypeReverse = (type) => {
  switch (type) {
    case InfinityEnums.ConnectorType.IEC_62196_T1:
      return InfinityEnums.OldConnectorType.TYPE_1
    case InfinityEnums.ConnectorType.IEC_62196_T1_COMBO:
      return InfinityEnums.OldConnectorType.TYPE_1_CCS
    case InfinityEnums.ConnectorType.IEC_62196_T2:
      return InfinityEnums.OldConnectorType.TYPE_2
    case InfinityEnums.ConnectorType.DOMESTIC_F:
      return InfinityEnums.OldConnectorType.SCHUKO
    case InfinityEnums.ConnectorType.GBT_AC:
      return InfinityEnums.OldConnectorType.GBT_AC
    case InfinityEnums.ConnectorType.IEC_62196_T2_COMBO:
      return InfinityEnums.OldConnectorType.COMBO_CCS
    case InfinityEnums.ConnectorType.CHADEMO:
      return InfinityEnums.OldConnectorType.CHADEMO
    case InfinityEnums.ConnectorType.GBT_DC:
      return InfinityEnums.OldConnectorType.GBT_DC
    case InfinityEnums.ConnectorType.TESLA_S:
      return InfinityEnums.OldConnectorType.NACS
    default:
      return type
  }
}
